import { ListContentLoader, PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const ChartSkeleton = () => (
    <Flex
        height="400px"
        padding="24px"
        gap="24px"
    >
        <PixelPlaceholderLoader
            height={"100%"}
            width={"100%"}
        />
        <Stack
            width="260px"
            alignItems="flex-start"
        >
            <Stack gap="8px">
                <PixelPlaceholderLoader
                    height={"40px"}
                    width={"100%"}
                />
                <PixelPlaceholderLoader
                    height={"14px"}
                    width={"70%"}
                />
            </Stack>
            <ListContentLoader />
        </Stack>
    </Flex>
);
